import { buildPageName } from '../utils/buildPageName'
import { PAGE_TYPES } from '@wix/wix-data-client-common'

import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import type { PresetDefinition } from '../../presets/types'

type Params = {
  editorSdkProxy: EditorSDK
  preset: PresetDefinition
  collectionName: string
}

export const addPage = async ({
  editorSdkProxy,
  preset,
  collectionName,
}: Params) => {
  const pageDefinition = preset.pages.find(page => page.type === 'indexPage')

  const pageName = buildPageName({
    collectionName,
    pageType: PAGE_TYPES.COLLECTION,
  })

  const pageRef = await editorSdkProxy.document.pages.add({
    title: pageName,
    definition: pageDefinition!.definition,
    shouldAddMenuItem: true,
    shouldNavigateToPage: false,
  })

  return { pageRef }
}
